<template>
  <vs-prompt
    class="operation-report-csv-download-dialog max-w-fit"
    :title="title"
    :color="color"
    :type="type"
    :accept-text="acceptText"
    :cancel-text="cancelText"
    :active="active"
    @accept="onAccept"
    @cancel="onCancel"
    @close="onCancel"
  >
    <div>
      {{ confirmText }}
    </div>
  </vs-prompt>
</template>

<script>
import { ColorMixin } from "@/mixins";
const { AISEA_COLOR } = ColorMixin.data();

const EVENTS = {
  ACCEPT: "accept",
  CANCEL: "cancel",
};

export default {
  name: "OperationReportCsvDownloadDialog",
  props: {
    title: {
      type: String,
      default() {
        return this.$t("Views.Operation.Download.Dialog.title");
      },
    },
    type: {
      type: String,
      default: "alert",
    },
    color: {
      type: String,
      default: AISEA_COLOR.BLUE,
    },
    acceptText: {
      type: String,
      default() {
        return this.$t("Views.Operation.Download.Dialog.acceptText");
      },
    },
    cancelText: {
      type: String,
      default() {
        return this.$t("Views.Operation.Download.Dialog.cancelText");
      },
    },
    active: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default() {
        return this.$t("Views.Operation.Download.Dialog.confirmText");
      },
    },
  },
  methods: {
    onAccept() {
      this.$emit(EVENTS.ACCEPT);
    },
    onCancel() {
      this.$emit(EVENTS.CANCEL);
    },
  },
};
</script>

<style lang="scss">
.operation-report-csv-download-dialog {
  .vs-dialog {
    width: 270px;
    .vs-dialog-cancel-button {
      background: #f8f8f8 !important;
    }
  }
}
</style>
